import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import { AuthProvider, useAuth } from './AuthContext'
import LoginPage from './pages/LoginPage'
import AdminLayout from './layout/AdminLayout'
import ServicesPage from './pages/ServicesPage'
import ServiceEditor from './pages/ServiceEditor'
import SubServiceEditor from './pages/SubServiceEditor'

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth()
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />
}

function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <Routes>
                <Route index element={<Navigate to="services" replace />} />
                <Route path="services" element={<ServicesPage />} />
                <Route path="services/:id" element={<ServiceEditor />} />
                <Route path="services/:id/sub/:subId" element={<SubServiceEditor />} />
              </Routes>
            </AdminLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

const adminTheme = {
  primaryColor: 'red',
  fontFamily: 'Inter, sans-serif',
  colors: {
    dark: [
      '#d0d0d0',
      '#b0b0b0',
      '#808080',
      '#5a5a5a',
      '#3a3a3a',
      '#2a2a2a',
      '#212121',
      '#171717',
      '#121212',
      '#0d0d0d',
    ],
  },
}

export default function AdminApp() {
  return (
    <MantineProvider defaultColorScheme="dark" theme={adminTheme}>
      <Notifications position="top-right" />
      <AuthProvider>
        <AdminRoutes />
      </AuthProvider>
    </MantineProvider>
  )
}
